export const enum SWEvents {
  Ready = "sw-ready",
  Registered = "sw-registered",
  Cached = "sw-cached",
  UpdateFound = "sw-updatefound",
  Updated = "sw-updated",
  Offline = "sw-offline",
  Error = "sw-error",
}
